<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      :show="false"
      addShowPower="/activereentrymanage/add"
    >
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" :isShow="false">
      <el-table-column
        prop="name"
        label="名称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="number"
        label="第几返"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="money"
        label="金额"
        min-width="120"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="hhr1"
        label="初级合伙人"
        min-width="120"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="hhr2"
        label="中级合伙人"
        min-width="120"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="hhr3"
        label="高级合伙人"
        min-width="120"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="1"
            inactive-value="0"
            @change="statusturns($event, scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="hasPerm('/activereentrymanage/update')"
        label="操作"
        min-width="260"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="hasPerm('/activereentrymanage/update')"
            @click="openAddDialog(scope.row)"
            >修改
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
      dialogWidth="439px"
    >
      <el-form-item label-width="127px" label="名称">
        <el-input
          type="text"
          maxlength="100"
          v-model="dialogModel.name"
          placeholder="请输入"
          style="width: 180px"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label-width="127px" label="第几返">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.number"
          placeholder="请输入"
          style="width: 180px"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label-width="127px" label="金额" prop="money">
        <el-input-number
          @change="hhrall()"
          v-model="dialogModel.money"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="127px" label="初级合伙人(元)" prop="hhr1">
        <el-input-number
          @change="hhrall()"
          v-model="dialogModel.hhr1"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="127px" label="中级合伙人(元)" prop="hhr2">
        <el-input-number
          @change="hhrall()"
          v-model="dialogModel.hhr2"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="127px" label="高级合伙人(元)" prop="hhr3">
        <el-input-number
          @change="hhrall()"
          v-model="dialogModel.hhr3"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import TransactionService from "service/TransactionService";

import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "activereentrymanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      show: false,
      formModel: {},
      tableData: [],
      submitService: TransactionService.activereentrymanageList,
      itemId: "",
      dialogModel: {
        name: "",
        number: undefined,
        money: undefined,
        hhr1: undefined,
        hhr2: undefined,
        hhr3: undefined,
      },
      dialogRules: {
        money: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                value == "" ||
                value +
                  this.dialogModel.hhr1 +
                  this.dialogModel.hhr2 +
                  this.dialogModel.hhr3 <=
                  60
              ) {
                return callback();
              } else {
                callback(new Error("金额、初、中、高级合伙人总和不得大于60"));
              }
            },
          },
        ],
        hhr1: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                value == "" ||
                value +
                  this.dialogModel.money +
                  this.dialogModel.hhr2 +
                  this.dialogModel.hhr3 <=
                  60
              ) {
                return callback();
              } else {
                callback(new Error("金额、初、中、高级合伙人总和不得大于60"));
              }
            },
          },
        ],
        hhr2: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                value == "" ||
                value +
                  this.dialogModel.hhr1 +
                  this.dialogModel.money +
                  this.dialogModel.hhr3 <=
                  60
              ) {
                return callback();
              } else {
                callback(new Error("金额、初、中、高级合伙人总和不得大于60"));
              }
            },
          },
        ],
        hhr3: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                value == "" ||
                value +
                  this.dialogModel.hhr1 +
                  this.dialogModel.hhr2 +
                  this.dialogModel.money <=
                  60
              ) {
                return callback();
              } else {
                callback(new Error("金额、初、中、高级合伙人总和不得大于60"));
              }
            },
          },
        ],
      },
      isFlag: false,
      currentTypes: {},
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      this.params = {};
      return this.params;
    },
    dialogData() {
      const params = {
        money: this.dialogModel.money * 100,
        hhr1: this.dialogModel.hhr1 * 100,
        hhr2: this.dialogModel.hhr2 * 100,
        hhr3: this.dialogModel.hhr3 * 100,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return TransactionService.activereentrymanageEdit;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {};
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    statusturns($event, scope) {
      this.doStatus($event, scope);
    },
    doStatus($event, scope) {
      this.doLoad(
        TransactionService.activereentrymanageStatus,
        {
          id: scope.id,
          status: $event,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.dialogModel.money = this.dialogModel.money / 100;
        this.dialogModel.hhr1 = this.dialogModel.hhr1 / 100;
        this.dialogModel.hhr2 = this.dialogModel.hhr2 / 100;
        this.dialogModel.hhr3 = this.dialogModel.hhr3 / 100;
      }
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        name: "",
        number: undefined,
        money: undefined,
        hhr1: undefined,
        hhr2: undefined,
        hhr3: undefined,
      };
      this.itemId = "";
    },
    hhrall() {
      this.$refs.formDialog.validateField("money");
      this.$refs.formDialog.validateField("hhr1");
      this.$refs.formDialog.validateField("hhr2");
      this.$refs.formDialog.validateField("hhr3");
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
      });
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/Transaction/ActiveReentryManage.vue